import { eventTargetIsEditable } from './isEditableTarget';

/** Left and up go back a page. Right and down go forward. */
export function pdfPageStepFromArrowKey(event: KeyboardEvent): -1 | 1 | null {
  if (event.metaKey || event.ctrlKey || event.altKey) return null;
  if (eventTargetIsEditable(event)) return null;
  if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') return -1;
  if (event.key === 'ArrowRight' || event.key === 'ArrowDown') return 1;
  return null;
}
